import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	approvalStepHeading: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-heading',
		defaultMessage: 'Approval for "{approvalStatus}" status',
		description:
			'The heading for an approval step in an approval data field card on the SWIFT page',
	},
	approvalStepInformationNoDefaults: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-information-no-defaults',
		defaultMessage:
			'{whoChoosesApprovers} must add {numberOfApprovers, plural, one {# approver} other {# approvers}} to the "{approverListFieldName}" field',
		description:
			'The information displayed on the approval data field in the SWIFT page pertaining to the people that have to approve (without defaults)',
	},
	approvalStepInformationWithDefaults: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-information-with-defaults',
		defaultMessage: '{numberOfApprovers} of the following people must approve: ',
		description:
			'The information displayed on the approval data field in the SWIFT page pertaining to the people that have to approve (with defaults)',
	},
	approvalStepInformationWithDefaultsSingular: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.approvals-data.approval-step.approval-step-information-with-defaults-singular',
		defaultMessage: 'This person must approve: ',
		description:
			'The information displayed on the approval data field in the SWIFT page pertaining to the people that have to approve (with a singular default)',
	},
});
